import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { settingServices } from "../services/settingServices";

// Async thunk to fetch banners
export const fetchSetting = createAsyncThunk(
  "setting/fetchSetting",
  async (lang, { rejectWithValue }) => {
    try {
      const response = await settingServices(lang);
      return response.data.data; // Assuming the data is in response.data
    } catch (error) {
      return rejectWithValue(error.message); // Handle errors
    }
  }
);

// Define the initial state
const initialState = {
  setting: null,
  loading: false,
  error: null,
};

// Create slice
const settingSlice = createSlice({
  name: "setting",
  initialState,
  reducers: {}, // You can add other reducers here if needed
  extraReducers: (builder) => {
    builder
      .addCase(fetchSetting.pending, (state) => {
        state.loading = true; // Set loading to true when API call is in progress
        state.error = null; // Reset error
      })
      .addCase(fetchSetting.fulfilled, (state, action) => {
        state.loading = false;
        state.setting = action.payload; // Store banners data in the state
      })
      .addCase(fetchSetting.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Set error message in case of failure
      });
  },
});

// Export the reducer to be used in the store
export default settingSlice.reducer;
